module.exports = __webpack_public_path__ + "static/media/vasili.e717b8b8.jpg";